import * as React from 'react';
import type { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgUitklapbaar = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='currentColor'
      d='M18.99 12.02L15.13 8.16C14.94 7.96 14.62 7.96 14.43 8.16C14.24 8.36 14.23 8.67 14.43 8.86L17.58 12.01L14.44 15.16C14.24 15.36 14.24 15.67 14.44 15.87C14.64 16.07 14.95 16.07 15.15 15.87L19 12.02L18.99 12.02Z'
    />
    <path
      fill='currentColor'
      d='M9.72373 15.51C9.72373 15.38 9.67373 15.25 9.57373 15.16L6.42373 12.01L9.56373 8.86C9.76373 8.66 9.76373 8.35 9.56373 8.15C9.36373 7.95 9.05373 7.95 8.85373 8.15L5.00373 12L8.86373 15.86C9.06373 16.06 9.37373 16.06 9.57373 15.86C9.67373 15.76 9.72373 15.63 9.72373 15.51Z'
    />
  </svg>
);

export default SvgUitklapbaar;
